var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-overlay',{attrs:{"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"80","color":"indigo","width":"5"}})],1),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }